import { render, staticRenderFns } from "./WorkBookCompetitiveAnalysis.vue?vue&type=template&id=e4b0e5c8&scoped=true&"
import script from "./WorkBookCompetitiveAnalysis.vue?vue&type=script&lang=js&"
export * from "./WorkBookCompetitiveAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookCompetitiveAnalysis.vue?vue&type=style&index=0&id=e4b0e5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b0e5c8",
  null
  
)

export default component.exports